import { render } from "./AdminContentTagManagement.vue?vue&type=template&id=0a7a24bc&scoped=true"
import script from "./AdminContentTagManagement.vue?vue&type=script&lang=js"
export * from "./AdminContentTagManagement.vue?vue&type=script&lang=js"

import "./AdminContentTagManagement.vue?vue&type=style&index=0&id=0a7a24bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7a24bc"]])

export default __exports__